import { render } from "./CorteForm.vue?vue&type=template&id=dafb4a92"
import script from "./CorteForm.vue?vue&type=script&lang=js"
export * from "./CorteForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__